import isEqual from 'lodash/isEqual';
export var EnmuRecurrenceRule;
(function (EnmuRecurrenceRule) {
    EnmuRecurrenceRule["NONE"] = "NONE";
    EnmuRecurrenceRule["DAYLY"] = "DAYLY";
    EnmuRecurrenceRule["WEEKDAY"] = "WEEKDAY";
    EnmuRecurrenceRule["WEEKLY"] = "WEEKLY";
    EnmuRecurrenceRule["MONTHLY"] = "MONTHLY";
    EnmuRecurrenceRule["YEARLY"] = "YEARLY";
    EnmuRecurrenceRule["CUSTOM"] = "CUSTOM";
    EnmuRecurrenceRule["TEMP_INSERT"] = "TEMP_INSERT";
})(EnmuRecurrenceRule || (EnmuRecurrenceRule = {}));
export const parseRecurrenceRuleToFormRule = (rrule) => {
    var _a, _b;
    switch ((rrule === null || rrule === void 0 ? void 0 : rrule.freq) || (rrule === null || rrule === void 0 ? void 0 : rrule.userFreq)) {
        case 'DAILY':
            if ((rrule === null || rrule === void 0 ? void 0 : rrule.interval) === 1) {
                return EnmuRecurrenceRule.DAYLY;
            }
            return EnmuRecurrenceRule.TEMP_INSERT;
        case 'MONTHLY': {
            const isNthWeekday = Array.isArray(rrule === null || rrule === void 0 ? void 0 : rrule.bySetPos) && rrule.bySetPos.length > 0;
            if ((rrule === null || rrule === void 0 ? void 0 : rrule.interval) === 1 && ((_a = rrule.byMonth) === null || _a === void 0 ? void 0 : _a.length) === 0 && !(rrule === null || rrule === void 0 ? void 0 : rrule.until) && !isNthWeekday) {
                return EnmuRecurrenceRule.MONTHLY;
            }
            return EnmuRecurrenceRule.TEMP_INSERT;
        }
        case 'WEEKLY':
            if ((rrule === null || rrule === void 0 ? void 0 : rrule.interval) === 1) {
                if (Array.isArray(rrule === null || rrule === void 0 ? void 0 : rrule.byDay[0]) && isEqual(rrule === null || rrule === void 0 ? void 0 : rrule.byDay[0].slice().sort(), [1, 2, 3, 4, 5]) && !(rrule === null || rrule === void 0 ? void 0 : rrule.until)) {
                    return EnmuRecurrenceRule.WEEKDAY;
                }
                else if ((Array.isArray(rrule === null || rrule === void 0 ? void 0 : rrule.byDay[0]) && ((_b = rrule === null || rrule === void 0 ? void 0 : rrule.byDay[0]) === null || _b === void 0 ? void 0 : _b.length) !== 1) || (rrule === null || rrule === void 0 ? void 0 : rrule.until)) {
                    return EnmuRecurrenceRule.TEMP_INSERT;
                }
                return EnmuRecurrenceRule.WEEKLY;
            }
            return EnmuRecurrenceRule.TEMP_INSERT;
        case 'YEARLY':
            if ((rrule === null || rrule === void 0 ? void 0 : rrule.interval) === 1) {
                return EnmuRecurrenceRule.YEARLY;
            }
            return EnmuRecurrenceRule.TEMP_INSERT;
        default:
            return EnmuRecurrenceRule.NONE;
    }
};
export const getInsertRecurrenceRule = (form, autoPrev) => {
    var _a, _b;
    const { enmuRecurrenceRule: t, interval, byDay, byMonthDay, bySetPos } = form;
    const recurrenceRule = {
        interval: interval || 1,
        byDay: {},
        byMonthDay: [],
        byMonth: [],
        bySetPos: [],
    };
    const [actEnmuRecurrenceRule] = (_a = t) === null || _a === void 0 ? void 0 : _a.split('/');
    switch (actEnmuRecurrenceRule) {
        case EnmuRecurrenceRule.DAYLY:
            recurrenceRule.freq = 'DAILY';
            recurrenceRule.userFreq = recurrenceRule.freq;
            break;
        case EnmuRecurrenceRule.WEEKDAY:
            recurrenceRule.freq = 'WEEKLY';
            recurrenceRule.userFreq = recurrenceRule.freq;
            recurrenceRule.byDay = {
                0: [1, 2, 3, 4, 5],
            };
            break;
        case EnmuRecurrenceRule.WEEKLY:
            recurrenceRule.freq = 'WEEKLY';
            recurrenceRule.userFreq = recurrenceRule.freq;
            recurrenceRule.byDay = (t === null || t === void 0 ? void 0 : t.includes(EnmuRecurrenceRule.TEMP_INSERT)) ? byDay : {};
            break;
        case EnmuRecurrenceRule.MONTHLY:
            recurrenceRule.freq = 'MONTHLY';
            recurrenceRule.userFreq = recurrenceRule.freq;
            recurrenceRule.byMonthDay = (byMonthDay === null || byMonthDay === void 0 ? void 0 : byMonthDay.length) ? [...byMonthDay] : [];
            recurrenceRule.byDay = (t === null || t === void 0 ? void 0 : t.includes(EnmuRecurrenceRule.TEMP_INSERT)) || ((_b = bySetPos === null || bySetPos === void 0 ? void 0 : bySetPos.length) !== null && _b !== void 0 ? _b : 0) > 0 ? byDay || {} : {};
            recurrenceRule.bySetPos = bySetPos || [];
            if (autoPrev) {
                recurrenceRule.byMonthDay.push(-1);
                recurrenceRule.bySetPos = [1];
            }
            break;
        case EnmuRecurrenceRule.YEARLY:
            recurrenceRule.freq = 'YEARLY';
            recurrenceRule.userFreq = recurrenceRule.freq;
            break;
        default:
            return null;
    }
    return recurrenceRule;
};
